import React, { useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ color: [] }, { background: [] }],
    ['link', 'image'],
    ['clean']
  ]
};

const formats = [
  'header', 'bold', 'italic', 'underline', 'strike',
  'list', 'bullet', 'color', 'background', 'link', 'image'
];

/**
 * 富文本编辑器，兼容 Ant Design Form
 * <Form.Item name="itinerary"><RichTextEditor placeholder="请输入行程" /></Form.Item>
 */
const RichTextEditor = ({ value, onChange, placeholder, style }) => {
  const editorStyle = useMemo(() => ({
    ...style,
    minHeight: style?.minHeight || 200
  }), [style]);

  return (
    <div style={editorStyle}>
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={onChange}
        placeholder={placeholder}
        modules={modules}
        formats={formats}
        style={{ height: editorStyle.minHeight - 42 }}
      />
    </div>
  );
};

export default RichTextEditor;
